export enum TrackEventName {
  CHAT_SEND = 'CHAT_SEND',
  PROJECT_FILES_UPLOAD = 'PROJECT_FILES_UPLOAD',
  LOGIN = 'LOGIN'
}
